import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
//import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true, // Dark モードを有効にする
    themes: {
      dark: {
        primary: "#f7e04b",
        secondary: "#212121",
        accent: "#f7e04b",
        // info: colors.lime,
        // success: colors.orange,
        // warning: colors.teal,
        background: "#121212",
      },
    },
    options: { customProperties: true },
  },
});
